<template>
	<div>
		<div
			class="modal fade"
			id="AMCPopUp"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Add AMC</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "resetAction()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px">
						<div class="spinner-border" v-if="isLoading" style="margin:auto;display:block"/>
						<div v-else style = "padding:20px" class = "col-md-11" >
								<AMCAccountData
									ref="AMC"
									:AMCList = "AMCList"
									:index = "index"
								/>
						</div>
					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary"  @click = "saveAMC()">Save</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

import Multiselect from "vue-multiselect";
import moment from "moment";
import datePicker from 'vue-bootstrap-datetimepicker';
import AMCAccountData from '@/components/account-management/AMCAccountData.vue';

export default {
	name: "AMCPopUp",
	components:{Multiselect, moment, datePicker, AMCAccountData},
	props:[ "AMCList", "index"],
	data(){
		return{
			AMC:{
				go_AMC_cd:"",
				AMC_name:"",
				vc_alias:"",
				account_type:"",
				reporting_date:"",
				AMC:null,
				AMC_id:'',
				temp_AMC:'',
				country_currency:null,
			},
			isLoading:false,
			isEdit:false,
			submitted:false,
			AMCAdded:false,
			client_added:true,
			isDisableName:false,
			isDisableAlias:false,
			toggleData:false,
			countryList:[],
		}
	},
	watch:{
		
	},
	computed: {

	},
	mounted() {
		
	},
	methods: {	
		
	}
}

</script>
